<ion-avatar> {{ this.userLetter() }} </ion-avatar>
